import {CreateControllerFn} from '@wix/yoshi-flow-editor'

import {isTemplateView} from '../../utils/flowAPI'
import {EXPERIMENTS, TransactionNames} from '../../utils/constants'
import {generateBreadcrumbsSD} from '../../utils/getBreadcrumbsConfig'

import {initExperiencesListStorage, mockExperiencesListStorage} from './storage'

const createController: CreateControllerFn = async ({flowAPI, controllerConfig}) => {
  const siteStructure = await controllerConfig.wixCodeApi.site.getSiteStructure({
    includePageId: true,
  })
  const experiments = flowAPI.experiments
  const isSeoIntegrationEnabled = experiments.enabled(EXPERIMENTS.isSeoIntegrationEnabled)

  return {
    async pageReady() {
      const pageLoadTransaction = flowAPI.panoramaClient.transaction(TransactionNames.pageLoad)
      pageLoadTransaction.start()

      const isEditor = flowAPI.environment.isEditor
      const isPreview = flowAPI.environment.isPreview
      const isTemplate = isTemplateView(flowAPI)

      const shouldMockStorage = isEditor || isPreview || isTemplate

      const storage = shouldMockStorage
        ? mockExperiencesListStorage(flowAPI, controllerConfig, siteStructure)
        : initExperiencesListStorage(flowAPI, controllerConfig, siteStructure)

      flowAPI.controllerConfig.setProps(storage)

      const breadCrumbsSD = generateBreadcrumbsSD(storage.breadcrumbsConfig)
      if (isSeoIntegrationEnabled) {
        flowAPI.controllerConfig.wixCodeApi.seo.renderSEOTags({
          itemType: 'BREADCRUMBS_COMPONENT',
          itemData: {items: breadCrumbsSD.itemListElement},
        })
      } else {
        await flowAPI.controllerConfig.wixCodeApi.seo.setStructuredData([breadCrumbsSD])
      }

      await Promise.all([storage.getReservationLocations(), storage.getExperiences()])

      pageLoadTransaction.finish()
    },
  }
}

export default createController
